import DetailModal, { ContentList, Html } from '.';
import { needsAssets } from '../../content/needsPresentation';
import { useDetailModalStyles } from './DetailModal.styles';

type NeedsDetailModalProps = {
  open: boolean;
  onCancel: () => void;
  variable: any;
  modalStaticBlockElement: any;
  isPro?: boolean;
};

const NeedsDetailModal = ({
  open,
  onCancel,
  variable,
  modalStaticBlockElement,
  isPro = true,
}: NeedsDetailModalProps) => {
  const classes = useDetailModalStyles();
  if (!variable) return null;
  const content = modalStaticBlockElement[variable.key];
  const specificText = isPro ? 'professionnels' : 'personnels';
  return (
    <DetailModal
      open={open}
      onCancel={onCancel}
      label={variable.label}
      img={needsAssets[variable.key]?.image || variable.path}
      color={variable.color}
      value={variable.score}
      totalValue={125}
      introduction={
        <>
          <h3>Votre besoin pour être heureux(se)</h3>
          <Html text={content.toBeHappy.content} />
        </>
      }>
      <section
        className={`${classes.panel} ${classes.columns}`}
        style={{ backgroundColor: variable.color }}>
        <div>
          <h2>{`Les environnements ${specificText} à privilégier :`}</h2>
          <ContentList items={content.environmentToPrivilege.content} />
        </div>
        <div>
          <h2>{`Les environnements ${specificText} à éviter :`}</h2>
          <ContentList items={content.environmentToAvoid.content} />
        </div>
      </section>
    </DetailModal>
  );
};

export default NeedsDetailModal;
